// import React from "react";
// import { Dialog, Transition } from "@headlessui/react";

// const RateListModal = ({ show, handleClose, data, onSelect }) => {
//   // Ensure data is an array
//   const rateList = data?.getRateList || [];
//   console.log("RATELIST DETAILS:", rateList);

//   return (
//     <Transition show={show} as={React.Fragment}>
//       <Dialog as="div" className="relative z-10" onClose={handleClose}>
//         {/* Dialog content */}
//         <div className="fixed inset-0 z-10 overflow-y-auto">
//           <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
//             <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
//               <div className="sm:flex sm:items-start">
//                 <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
//                   <h3 className="text-lg font-medium leading-6 text-gray-900">
//                     Select Land Rate
//                   </h3>
//                 </div>
//               </div>
//               <div className="mt-5">
//                 <table className="w-full border-collapse border border-gray-300">
//                   <thead>
//                     <tr className="bg-gray-200">
//                       <th className="border border-gray-300 px-4 py-2">
//                         Location of Land
//                       </th>
//                       <th className="border border-gray-300 px-4 py-2">
//                         Type of Land
//                       </th>
//                       <th className="border border-gray-300 px-4 py-2">
//                         Area Measurement of Property
//                       </th>
//                       <th className="border border-gray-300 px-4 py-2">
//                         Circle Rate
//                       </th>
//                       <th className="border border-gray-300 px-4 py-2">Unit</th>
//                       <th className="border border-gray-300 px-4 py-2">
//                         Select
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {rateList.map((item, index) => (
//                       <tr key={index}>
//                         <td className="border border-gray-300 px-4 py-2">
//                           {item.pargananame}
//                         </td>
//                         <td className="border border-gray-300 px-4 py-2">
//                           {item.areadesc}
//                         </td>
//                         <td className="border border-gray-300 px-4 py-2">
//                           {item.areamajdesc}
//                         </td>
//                         <td className="border border-gray-300 px-4 py-2">
//                           {item.rate}
//                         </td>
//                         <td className="border border-gray-300 px-4 py-2">
//                           {item.unit}
//                         </td>
//                         <td className="border border-gray-300 px-4 py-2">
//                           <button
//                             onClick={() => onSelect(item)}
//                             className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
//                           >
//                             Select
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
//                 <button
//                   onClick={handleClose}
//                   className="mt-3 inline-flex w-full justify-center rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto sm:text-base"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Dialog>
//     </Transition>
//   );
// };

// export default RateListModal;

// import React from "react";
// import { Dialog, Transition } from "@headlessui/react";

// const RateListModal = ({ show, handleClose, data, onSelect }) => {
//   const rateList = data?.getRateList || [];
//   console.log("RATELIST DETAILS:", rateList);

//   return (
//     <Transition show={show} as={React.Fragment}>
//       <Dialog as="div" className="relative z-10" onClose={handleClose}>
//         {/* Blurred Background */}
//         <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm" />

//         {/* Modal Container */}
//         <div className="fixed inset-0 z-20 flex items-center justify-center p-4">
//           <Dialog.Panel className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-6">
//             {/* Modal Header */}
//             <div className="flex justify-between items-center border-b pb-3">
//               <h3 className="text-lg font-medium text-gray-900">
//                 Select Land Rate
//               </h3>
//               <button
//                 onClick={handleClose}
//                 className="text-gray-500 hover:text-gray-700 text-xl"
//               >
//                 ✖
//               </button>
//             </div>

//             {/* Scrollable Table Section */}
//             <div className="mt-4 max-h-[500px] overflow-y-auto">
//               <table className="w-full border-collapse border border-gray-300">
//                 <thead>
//                   <tr className="bg-gray-200">
//                     <th className="border border-gray-300 px-4 py-2">
//                       Location of Land
//                     </th>
//                     <th className="border border-gray-300 px-4 py-2">
//                       Type of Land
//                     </th>
//                     <th className="border border-gray-300 px-4 py-2">
//                       Area Measurement
//                     </th>
//                     <th className="border border-gray-300 px-4 py-2">
//                       Circle Rate
//                     </th>
//                     <th className="border border-gray-300 px-4 py-2">Unit</th>
//                     <th className="border border-gray-300 px-4 py-2">Select</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rateList.map((item, index) => (
//                     <tr key={index}>
//                       <td className="border border-gray-300 px-4 py-2">
//                         {item.pargananame}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2">
//                         {item.areadesc}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2">
//                         {item.areamajdesc}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2">
//                         {item.rate}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2">
//                         {item.unit}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2">
//                         <button
//                           onClick={() => onSelect(item)}
//                           className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
//                         >
//                           Select
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Modal Footer */}
//             <div className="flex justify-end mt-4">
//               <button
//                 onClick={handleClose}
//                 className="bg-red-600 hover:bg-red-500 text-white font-medium py-2 px-4 rounded"
//               >
//                 Close
//               </button>
//             </div>
//           </Dialog.Panel>
//         </div>
//       </Dialog>
//     </Transition>
//   );
// };

// export default RateListModal;

import React from "react";
import { Dialog, Transition } from "@headlessui/react";

const RateListModal = ({ show, handleClose, data, onSelect }) => {
  const rateList = data?.getRateList || [];
  console.log("RATELIST DETAILS:", rateList);

  return (
    <Transition show={show} as={React.Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        {/* Blurred Background */}
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm" />

        {/* Modal Container */}
        <div className="fixed inset-0 z-20 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-6 static">
            {/* Modal Header */}
            <div className="flex justify-between items-center border-b pb-3">
              <h3 className="text-lg font-medium text-gray-900">
                Select Land Rate
              </h3>
              <button
                onClick={handleClose}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ✖
              </button>
            </div>

            {/* Scrollable Table Section */}
            <div className="mt-4 max-h-[500px] overflow-y-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 px-4 py-2">
                      Location of Land
                    </th>
                    <th className="border border-gray-300 px-4 py-2">
                      Type of Land
                    </th>
                    <th className="border border-gray-300 px-4 py-2">
                      Area Measurement
                    </th>
                    <th className="border border-gray-300 px-4 py-2">
                      Circle Rate
                    </th>
                    <th className="border border-gray-300 px-4 py-2">Unit</th>
                    <th className="border border-gray-300 px-4 py-2">Select</th>
                  </tr>
                </thead>
                <tbody>
                  {rateList.map((item, index) => (
                    <tr key={index}>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.pargananame}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.areadesc}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.areamajdesc}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.rate}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.unit}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        <button
                          onClick={() => onSelect(item)}
                          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Modal Footer */}
            <div className="flex justify-end mt-4">
              <button
                onClick={handleClose}
                className="bg-red-600 hover:bg-red-500 text-white font-medium py-2 px-4 rounded"
              >
                Close
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </Transition>
  );
};

export default RateListModal;
